export const ValidateFields = (
  name,
  lastname,
  phone,
  email,
  confirmEmail,
  birthdate,
  address,
  city,
  showCedulaInput,
  cedula,
  documents,
  cvDocument,
  gender,
  size
) => {
  const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
  const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;

  if (name.trim() === "") {
    return "El campo nombre es requerido";
  }

  if (name.trim().length < 3) {
    return "El nombre debe tener al menos 3 caracteres";
  }

  if (!/^[a-zA-ZáéíóúÁÉÍÓÚ\s]+$/.test(name)) {
    return "El campo nombre solo puede contener caracteres alfabéticos";
  }

  // lastname validation
  if (lastname.trim() === "") {
    return "El campo apellido es requerido";
  }

  if (lastname.trim().length < 4) {
    return "El apellido debe tener al menos 4 caracteres";
  }

  if (!/^[a-zA-ZáéíóúÁÉÍÓÚ\s]+$/.test(lastname)) {
    return "El campo apellido solo puede contener caracteres alfabéticos";
  }

  // gender validation
  if (!gender) {
    return "El campo género es requerido";
  }

  if (!size) {
    return "El campo size es requerido";
  }

  // phone validation
  if (phone.trim() === "") {
    return "El campo teléfono es requerido";
  }

  if (!phoneRegex.test(phone)) {
    return "El teléfono ingresado no tiene el formato correcto";
  }

  // email validation
  if (email.trim() === "") {
    return "El campo correo electrónico es requerido";
  }

  if (!emailRegex.test(email)) {
    return "El correo electrónico no tiene el formato correcto";
  }

  // confirmEmail validation
  if (confirmEmail.trim() === "") {
    return "El campo de confirmación del correo electrónico es requerido";
  }

  if (!emailRegex.test(confirmEmail)) {
    return "El correo de confirmación no tiene el formato correcto";
  }

  if (email !== confirmEmail) {
    return "Los correos electrónicos no coinciden";
  }

  // address validation
  if (address.trim() === "") {
    return "El campo dirección es requerido";
  }

  if (address.trim().length < 10) {
    return "La dirección debe tener al menos 10 caracteres";
  }

  // city validation
  if (city.trim() === "") {
    return "El campo ciudad es requerido";
  }

  if (city.trim().length < 4) {
    return "La ciudad debe tener al menos 4 caracteres";
  }

  // birthdate validation
  if (!birthdate) {
    return "El campo fecha de nacimiento es requerido";
  }

  const calculateAge = (birthDate) => {
    const today = new Date();
    const birthDateObj = new Date(birthDate);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
    ) {
      age--;
    }
    return age;
  };

  // cedula validation
  if (
    calculateAge(birthdate) >= 18 &&
    showCedulaInput &&
    cedula.trim() === ""
  ) {
    return "El campo cédula es requerido";
  }

  const cedulaRegex = /^\d{3}-\d{7}-\d{1}$/;

  if (
    calculateAge(birthdate) >= 18 &&
    showCedulaInput &&
    !cedulaRegex.test(cedula.trim())
  ) {
    return "La cédula ingresada no tiene el formato correcto";
  }

  // documents validation
  if (calculateAge(birthdate) >= 18 && documents.length < 2) {
    return "Debe adjuntar ambos lados de su cédula";
  }

  if (!cvDocument) {
    return "El Curriculum Vitae es requerido";
  }

  return null;
};
